import {
  proStudioUrqlGql as urqlGql,
  SolutionEnvironmentsEnum,
} from '@pypestream/api-services';
import { throwErrorWithId } from '@pypestream/utils';

import { ProStudioContext, ProStudioEvents } from '../prostudio.xstate.types';
import { loadBotPypes } from './load-bot-pypes';
import { Pype } from '../prostudio.api-service.types';

export const toggleAnalyticsForChannel = async (
  ctx: ProStudioContext,
  event: ProStudioEvents
): Promise<{ botPypes: Pype[] } | void> => {
  if (event.type !== 'analyticsToggle') {
    return;
  }

  const projectId = ctx.project?.id;

  if (!projectId) {
    event.payload.onError?.();
    throwErrorWithId('Project ID is required');
    return;
  }

  const { streamId, env, enabled, onDone, onError } = event.payload;

  const solutionEnv =
    env === 'live'
      ? SolutionEnvironmentsEnum.Live
      : SolutionEnvironmentsEnum.Sandbox;

  const result = await urqlGql.updateAnalyticsForChannel({
    enabled,
    streamId,
    projectId,
    env: solutionEnv,
  });

  if (result.error) {
    onError?.();
    throwErrorWithId(result.error.message);
    return;
  }

  // The backend returns a bare boolean; `false` (or nullish) means the
  // connect/disconnect was refused server-side (e.g. permission/provisioning,
  // see PSTUDIO-3109) with NO GraphQL `errors`. Treat it as a failure so the
  // optimistic tag reverts (onError) and the user gets the error toast wired on
  // togglingAnalyticsFlow.onErrorActions — instead of a silent no-op.
  if (!result.data?.admin_?.updateAnalyticsForChannel) {
    onError?.();
    throwErrorWithId('Failed to update analytics settings for channel');
    return;
  }

  onDone?.();

  const { botPypes } = await loadBotPypes(ctx, event);

  return { botPypes };
};
